import * as React from "react";
import { InputGroup, Intent, MenuItem, Menu, ColorPicker, CustomLabel, } from "@focus/focusUI";
import produce from "immer";
export const GrafosSurfacesDialog = (props) => {
    const { content, onUpdate } = props;
    const [selected, setSelected] = React.useState(-1);
    const selectedSurface = selected >= 0 && content.surfaces[selected];
    const updateColor = (color) => {
        const updatedContent = produce(content, (draft) => {
            const currentObject = draft.surfaces[selected];
            currentObject.color = color.hex;
        });
        onUpdate(updatedContent.surfaces);
    };
    const updatefield = (fieldName) => (event) => {
        const value = event.target ? event.target.value : event;
        const updatedContent = produce(content, (draft) => {
            const currentObject = draft.surfaces[selected];
            currentObject[fieldName] = value;
        });
        onUpdate(updatedContent.surfaces);
    };
    return (React.createElement("div", { className: "focus-grafosConfig" },
        React.createElement("div", { className: "focus-grafosConfig_leftPanel" },
            React.createElement(CustomLabel, { text: "Surface" },
                React.createElement(Menu, null, content.surfaces.map((_, index) => (React.createElement(MenuItem, { key: index, onClick: () => {
                        setSelected(index);
                    }, text: `Surface_${index}`, active: selected === index })))))),
        React.createElement("div", null, selectedSurface && (React.createElement(React.Fragment, null,
            React.createElement(CustomLabel, { text: "Title" },
                React.createElement(InputGroup, { intent: Intent.PRIMARY, onChange: updatefield("title"), value: selectedSurface.title })),
            React.createElement(CustomLabel, { text: "color" },
                React.createElement(ColorPicker, { onChange: updateColor, color: selectedSurface.color })))))));
};
//# sourceMappingURL=GrafosSurfacesDialog.js.map